import React from 'react';
import {Button} from 'reactstrap';
import AdminAudioTools from './adminAudio';
import AdminUserTools from './adminUserTools';
import TextTools from './adminTextTools';
import {isAdmin} from '../functions/adminFunctions';
import { Redirect} from 'react-router-dom';
import { withRouter } from 'react-router';
// function PopulateUsers({user}) {
//     return(
        
//     );
// }

class AdminTools extends React.Component{
    constructor(props){
        super(props);
        this.state={
            // states for Range Query on User
            userQueryDiv:"",
            textQueryDiv:"none",
            audioQueryDiv:"none"
        }
    }

    componentDidMount =()=>{
        if (!localStorage.getItem('isAdmin')) {
            const checkAdminStatus = async () => {
                try {
                    const resp = await isAdmin(); 
        
                    if (!resp || !resp.success) {
                        this.props.history.push('/login'); 
                    } else {
                        localStorage.setItem('isAdmin', true);  
                    }
                } catch (error) {
                    console.error("Error while checking admin status:", error);
                    this.props.history.push('/login');  // Redirect to login on error
                }
            };
        }
    }


    toggleUserQueryDiv=()=>{
        this.setState({
            userQueryDiv:"",
            textQueryDiv:"none",
            audioQueryDiv:"none"
        });
    }
    

    toggleTextQueryDiv=()=>{
        this.setState({
            userQueryDiv:"none",
            textQueryDiv:"",
            audioQueryDiv:"none"
        });
    }

    toggleAudioQueryDiv=()=>{
        this.setState({
            userQueryDiv:"none",
            textQueryDiv:"none",
            audioQueryDiv:""
        });
    }


    render(){
        if(!this.props.user.isAuthenticated){
            return(
                <Redirect to='/login'/>
            );
        }
        if(!localStorage.getItem('isAdmin')){
            return(
                <div>Not Allowed</div>
                );
        }
        else{
            return(
                <div className="container mt-2">
                    <div className="row m-auto">
                        <div>
                            <Button color="primary"
                                onClick={()=>this.toggleUserQueryDiv()}
                                >User</Button>
                        </div>
                        <div className="ml-2">
                            <Button color="primary"
                                onClick={()=>this.toggleTextQueryDiv()}
                                >Text</Button>
                        </div>
                        <div className="ml-2">
                            <Button color="primary"
                                onClick={()=>this.toggleAudioQueryDiv()}
                                >Audio</Button>
                        </div>
                    </div>
    
                    <div
                        className="mt-2 col-12" 
                        style={{display:this.state.userQueryDiv}}>
                        <AdminUserTools/>
                    </div>
                    <div
                        className="mt-2" 
                        style={{display:this.state.audioQueryDiv}}>
                        <AdminAudioTools/>
                    </div>
                    <div
                        className="mt-2 col-12" 
                        style={{display:this.state.textQueryDiv}}>
                        <TextTools/>
                    </div>
                </div>
            );
        }
    }
}

export default withRouter(AdminTools);
